import api from "./api";

export const getGenders = async () => {

    const response = await api.get(`/api/genders`);
    return response.data;
}
export const getQualifications = async () => {
    const response = await api.get("/api/qualifications");
    return response.data;
};
export const getDegreeType = async (qualificationId) => {
    const response = await api.get(`/api/degreeType/qualification/${qualificationId}`)
    return response;
}
export const getDesignations = async () => {
    const response = await api.get(`/api/designations`);
    return response.data;
}
export const getRelationships = async () => {
    try {
        const response = await api.get(`/api/relationships`);
        return response.data;
    } catch (error) {
        console.error("Error fetching relationships:", error);
        throw error; // rethrow so component can handle it
    }
};
export const getUsers = async () => {
    const response = await api.get(`/api/list`);
    return response.data;
}

export const getRoles= async()=>{
    const response= await api.get(`/api/role`);
    return response.data;
}
export const getAccountTypes = async () => {
    const response = await api.get("/api/account-type");
    return response.data; // return only data
};
export const createEmployee = (payload) =>
    api.post("/api/employees", payload, {
        headers: { "Content-Type": "application/json" },
    });

export const updateEmployee = (id, payload) =>
    api.patch(`/api/employees/${id}`, payload, {
        headers: { "Content-Type": "application/json" },
    });


export const getReservationCategory = async () => {
    const response = await api.get('/api/resevationCategory');
    return response.data;
};

export const getNationalities = async () => {
    const response = await api.get('/api/nationality');
    return response.data;
};


export const getReligions = async () => {
    const response = await api.get('/api/religion');
    return response.data;
};

// export const getGenders = async () => {
//   const response = await api.get('/api/genders');
//   return response.data;
// };

export const getMaritalStatuses = async () => {
    const response = await api.get('/api/marital-status');
    return response.data;
};

export const personalDetailsSubmit = (payload) =>
    api.patch("/api/personal-info", payload, {
        headers: { "Content-Type": "application/json" },
    });

export const getStatesByCountry = async (countryId) => {
    try {
        const response = await api.get(`/api/states/nationality/${countryId}`);
        return response.data;
    } catch (error) {

        throw new Error('Error fetching states');
    }
};

export const getEmployeeDetailsBasedonEmployeeUniqueeId = async (employeeUniqueId) => {
    const response = await api.get(`/api/personal-info/${employeeUniqueId}`);
    return response.data;
}

export const getAddressDetailsBasedonEmployeeUniqueeId = async (employeeUniqueId) => {
    const response = await api.get(`/api/address/${employeeUniqueId}`);
    return response.data;
}

export const addressdetailsSubmit = async (employeeUniqueId, payload) => {
    try {
        const response = await api.patch(`/api/address/${employeeUniqueId}`, payload, {
            headers: { "Content-Type": "application/json" },
        });
        return response;
    } catch (error) {
        throw error; // let the caller handle it
    }
};

export const educationDetailsSubmit = async (employeeUniqueId, formData) => {
    try {
        const response = await api.post(`/api/education/${employeeUniqueId}`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return response; // return full axios response
    } catch (error) {
        throw error; // rethrow so caller can handle
    }
};
export const certificationsSubmit = async (employeeUniqueId, formData) => {
    try {
        const response = await api.post(`/api/certificates/${employeeUniqueId}`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return response; // return full axios response
    } catch (error) {
        throw error; // rethrow so caller can handle
    }
};
export const experienceSubmit = async (employeeUniqueId, formDataObj) => {
    try {
        const response = await api.post(`/api/experience/${employeeUniqueId}`, formDataObj, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return response; // return full axios response
    } catch (error) {
        throw error; // rethrow so caller can handle
    }
};
export const bandkDetailsSubmit = async (employeeUniqueId, formDataObj) => {
    try {
        const response = await api.post(`/api/bank-details/${employeeUniqueId}`, formDataObj, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return response; // return full axios response
    } catch (error) {
        throw error; // rethrow so caller can handle
    }
};
export const submitIdDetails = async (employeeUniqueId, formData) => {
    try {
        const response = await api.post(`/api/id-details/${employeeUniqueId}`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return response; // return full response
    } catch (error) {
        throw error; // rethrow for component to handle
    }
};

export const getMobileOtpPreview = async (employeeUniqueId) => {
    const response = await api.post(`/api/personal-info/generate/${employeeUniqueId}?type=MOBILE`);
    return response;

}
export const mobileVerifyOtp = async (payload) => {
    const response = await api.post(`/api/personal-info/verify`, payload, {
        headers: {
            "Content-Type": "application/json",
        },
    })
    return response;
}
export const getEmailOtpPreview = async (employeeUniqueId) => {
    const response = await api.post(`/api/personal-info/generate/${employeeUniqueId}?type=EMAIL`);
    return response;

}

export const emailVerifyOtp = async (payload) => {
    const response = await api.post(`/api/personal-info/verify`, payload, {
        headers: {
            "Content-Type": "application/json",
        },
    })
    return response;
}
export const personalInfoCompleteSubmit = async (payload) => {
    const response = await api.post(`/api/personal-info/complete`, payload, {
        headers: {
            "Content-Type": "application/json",
        },
    })
    return response;
}


export const getDesignationsPriority = async () => {
    const response = await api.get(`/api/designations/priority`);
    return response.data;
}

export const getSpecialzation = async () => {
    const response = await api.get("/api/specializations");
    return response.data;
};